import { Controller } from "@hotwired/stimulus";

import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ["content", "overlay", "title"];

  connect() {
    document.onkeydown = e => {
      const event = e || window.event;
      if (event.key === "Escape") {
        this.close();
      }
    };
  }

  click(e) {
    const { target } = e;
    if (target === this.overlayTarget || target === this.contentTarget) {
      this.close();
    }
  }

  open() {
    this.overlayTarget.classList.add("is-open");
  }

  close() {
    this.overlayTarget.classList.remove("is-open");
    this.contentTarget.innerHTML = "";
  }

  loadContent(url) {
    const headers = new Headers({
      "X-Requested-With": "XMLHttpRequest"
    });

    const request = new Request(url, {
      headers
    });

    fetch(request)
      .then(response => {
        if (response.ok) {
          return response.text();
        }
        throw new Error("Not Found");
      })
      .then(html => {
        this.contentTarget.innerHTML = html;
        this.open();
      })
      .catch(error => console.error("Error:", error));
  }

  like(event) {
    event.preventDefault();

    const data = new URLSearchParams({
      attachment_id: this.scope.data.get("attachment-id")
    }).toString();
    const elem = this.scope.element;
    const isLiked = elem.classList.contains("liked");
    const url = this.scope.data.get("like-url");
    const success = function() {
      if (isLiked) {
        elem.classList.remove("liked");
      } else {
        elem.classList.add("liked");
      }
    };

    Rails.ajax({
      type: "post",
      url,
      data,
      success
    });
  }
}
